<template>
	<dn-dialog
		content-class="dn-attribute-dialog"
		:btn-close="false"
		persistent
		ref="dialog"
		@before-show="onBeforeShow"
	>
		<template v-if="$slots.activator" slot="activator">
			<slot name="activator" />
		</template>

		<div class="dn-attribute-dialog__header">
			ご利用される方は
			<br />どなたですか？
		</div>
		<div class="dn-attribute-dialog__choices">
			<div class="dn-attribute-dialog__choices-header">
				<span class="dn-attribute-dialog__label">属性</span>
			</div>
			<div class="dn-attribute-dialog__choices-col" v-for="columns, index in columnSets" :key="index">
				<label v-for="column, index in columns" :key="index">
					<input type="radio" name="dn-user-attribute" :value="column.id" v-model="selected" />
					<span>{{column.label}}</span>
				</label>
			</div>
		</div>
		<div class="dn-attribute-dialog__footer">
			<p class="dn-attribute-dialog__footer-notice">※各属性に適した画面が表示されます</p>
			<a
				href="javascript:void(0);"
				class="dn-attribute-dialog__btn-apply dn-btn dn-btn--primary dn-btn--text-lg"
				@click="apply"
			>決定</a>
		</div>
		<!-- <a class="dn-attribute-dialog__twitter" href="https://x.com/kyotsu_DN" target="_blank">
			<div>
				<p class="head">X（旧Twitter）で最新情報をゲット</p>
				<p class="searchBox">
					<span class="searchIcon">
						<img src="/dn/center/resources/img/sns/twitter_search.png" width="14" height="14" />
					</span>
					@kyotsu_DN
				</p>
				<p>大学入学共通テストに関する情報を随時配信！</p>
			</div>
		</a> -->
	</dn-dialog>
</template>



<script>
	import UserAttributeModel from "models/UserAttributeModel";

	export default {
		data() {
			return {
				columnSets: [],
				selected: null
			};
		},

		created() {
			const userAttribute = new UserAttributeModel();
			this.columnSets = dn.h.arraySplitter(userAttribute.findAll(), 2);
		},

		computed: {
			dialog() {
				return this.$refs.dialog;
			},
			lineUrl() {
				return this.$store.getters["path/$join"]("root", "line.html");
			}
		},

		methods: {
			toggle() {
				return this.dialog.toggle();
			},
			show() {
				return this.dialog.show();
			},
			hide() {
				return this.dialog.hide();
			},

			apply() {
				if (this.selected === null) {
					dn.$alert("ご利用される方を選択してください。");
					return false;
				}

				try{
					dataLayer.push({ 'event': 'event_track', 'event_cat': 'ユーザー属性', 'event_act': '登録' , 'event_lab': dn.segments.userType.model.getLabelById(this.selected)});
				}catch(e){
					console.log(e);
				};

				this.$store.dispatch("segments/user/setId", this.selected);
				this.dialog.hide();
			},

			onBeforeShow() {
				this.selected = dn.$store.getters["segments/user/id"];
				this.$forceUpdate();
			}
		}
	};
</script>


// WEBPACK FOOTER //
// AttributeDialog.vue?96413202